import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import ApiURL from '../../api/ApiURL';

class MainFooter extends Component {
    constructor(props) {
        super(props);
        this.state={
            copyRightYear: ''
        }
    }    

    componentDidMount(){
        var current_year=new Date().getFullYear();
        this.setState({
            copyRightYear: current_year
        })
    }

    fbLinkClick = (e) => {
        e.preventDefault();
        var url = 'https://www.facebook.com/MyBoogyAirportTransfer';
        window.open(url, '_blank');

    }

    render() {
        const scrollTopImgURL = ApiURL.BaseImageURL + "/scroll-top.png";
        return (
            <>
                <footer>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 footer-items px-4">
                                <div className="footer-brand"><Link to="/">MyBoogy Airport Transfer</Link></div>
                                <div className="about-company">
                                    <p>
                                        MyBoogy Airport Transfer is a safe environment offers the lowest fare airport pick-ups and drops in the UK.
                                        S2P Services Limited (Trade name - MyBoogy Airport Transfer), is a company registered in the UK 
                                        (UK Company Number:13867775, VAT Number: 409832974, TFL License Number : 011005). 
                                        MyBoogy Airport Transfer has its own fleet of cars and collaboration with various other cab operators 
                                        all over the country to offer a seamless airport transfer experience to the customers. 
                                        Passengers from all over the globe can book a cab using our platform, to experience a hassle-free and timely 
                                        ride to the destination.
                                    </p>

                                    <form>
                                        <div className="form-area">
                                            <input type="email" placeholder="Email Address" />
                                            <button className="send-btn">Send</button>
                                        </div>
                                    </form>
                                </div>
                            </div>                            
                            <div className="col-lg-2 col-md-6 col-sm-12 footer-items px-4">
                                <h4>Quick Links</h4>
                                <ul className="footer-list">{/* 
                                    <li><NavLink to="/policy">Privacy Policy</NavLink></li> */}
                                    <li><NavLink to="/terms">Terms & Conditions</NavLink></li>
                                    <li><NavLink to="/faq">FAQ</NavLink></li>
                                    <li><NavLink to="/cookies-policy">Cookies Policy</NavLink></li>
                                    <li><NavLink to="/refund-policy">Refund Policy</NavLink></li>
                                </ul>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-items px-4">
                                <h4>Contact us</h4>
                                <ul className="footer-contact">
                                    <li><i className='fa fa-phone'></i> <Link to="tel:44(0)331-630-4110">+44(0)331-630-4110</Link></li>
                                    <li><i className="fa fa-envelope-o"></i> <Link to="mailto:contact-us@myboogy.co.uk">contact-us@myboogy.co.uk</Link> </li>
                                    <li><i className='fa fa-map-marker'></i> 450 Bath Road, London UB7 0EB, United Kingdom.</li>
                                </ul>
                                <div className="social-site">
                                    <NavLink to={"#"} onClick={this.fbLinkClick}><i className='fa fa-facebook'></i></NavLink>
                                    <NavLink to={"#"}><i className='fa fa-twitter'></i></NavLink>
                                    <NavLink to={"#"}><i className='fa fa-instagram'></i></NavLink>
                                </div>
                                <div className="scroll-top"><img src={scrollTopImgURL} alt="Scroll Top" /></div>

                            </div>
                        </div>
                    </div>
                </footer>
            </>
        );
    }
}

export default MainFooter;